<template>
  <div class="pl-page">
    <div ref="dropdownRef" class="pl-dropdown-wrap">
      <van-sticky>
        <van-dropdown-menu
          active-color="#337ECC"
          class="pl-dropdown-menu"
          :class="{ 'pl-dropdown-menu--dual': match.sportType === '棒球' }"
        >
          <van-dropdown-item
            v-model="groupValue"
            :options="groupOptions"
            @change="onGroupChange"
          />
          <van-dropdown-item
            v-if="match.sportType === '棒球' && baseballStatOptions.length"
            v-model="baseballStatProp"
            :options="baseballStatOptions"
            @change="onBaseballStatChange"
          />
        </van-dropdown-menu>
      </van-sticky>
    </div>

    <div v-if="pageLoading" class="pl-state">
      <van-loading size="24px" vertical>加载中...</van-loading>
    </div>
    <div v-else-if="!groupOptions.length" class="pl-state">
      <van-empty description="暂无赛事组别" />
    </div>
    <div v-else-if="unsupportedSport" class="pl-state">
      <van-empty :description="unsupportedTip" />
    </div>
    <div v-else class="pl-body">
      <!-- 足球 -->
      <div v-if="match.sportType === '足球'" class="pl-box">
        <aside class="pl-side">
          <button
            v-for="(item, i) in matchesType.footballs"
            :key="i"
            type="button"
            class="pl-side__item"
            :class="{ 'pl-side__item--active': listData.id === item.id }"
            @click="getInit(item.id, item.api)"
          >
            {{ item.val }}
          </button>
        </aside>
        <div class="pl-panel">
          <template v-if="listData.id === 'shooterList'">
            <div class="pl-grid pl-grid--fb3 pl-head">
              <span>球员</span><span>球队</span><span>次数</span>
            </div>
            <div
              v-for="(shooter, idx) in listData.shooterList"
              :key="shooter.id"
              class="pl-grid pl-grid--fb3 pl-row"
              :class="{ 'pl-row--alt': idx % 2 === 1 }"
            >
              <div class="pl-player">
                <span class="pl-rank" :class="{ 'pl-rank--top': shooter.top < 4 }">{{ shooter.top }}</span>
                <!--  -->
                <span class="pl-pname">{{ shooter.playerName }}</span>
              </div>
              <div class="pl-team">
                <img v-if="shooter.team.badge" :src="filterImage(shooter.team.badge, 20, 20)" alt="">
                <span>{{ shooter.team.teamAlias || shooter.team.name }}</span>
              </div>
              <div class="pl-num">
                {{ shooter.goalCount }}<template v-if="shooter.penaltyCount > 0">({{ shooter.penaltyCount }})</template>
              </div>
            </div>
            <p v-if="!listData.shooterList || !listData.shooterList.length" class="pl-empty-tip">还没有相关赛事数据，组委会正在录入中</p>
            <p v-else class="pl-foot">赛事数据统计由组委会提供</p>
          </template>

          <template v-else-if="listData.id === 'CardsData'">
            <div v-if="listData.CardsData && listData.CardsData.length">
              <div class="pl-grid pl-grid--card pl-head card-head">
                <span /><span /><span>红牌</span><span>黄牌</span>
              </div>
              <div
                v-for="(group, gIdx) in listData.CardsData"
                :key="cardGroupKey(group, gIdx)"
              >
                <div class="pl-grid pl-grid--card pl-row pl-row--group">
                  <div class="pl-card-logo">
                    <img v-if="group.teamInfo.team.badge" :src="filterImage(group.teamInfo.team.badge, 20, 20)" alt="">
                  </div>
                  <div class="pl-team pl-team--long">{{ group.teamInfo.team.teamAlias || group.teamInfo.team.name }}</div>
                  <div class="pl-num">{{ group.teamInfo.redCount }}</div>
                  <div class="pl-num">{{ group.teamInfo.yellowCount }}</div>
                </div>
                <div
                  v-for="player in group.teamPlayers"
                  :key="player.playerId"
                  class="pl-grid pl-grid--card pl-row pl-row--sub"
                >
                  <span /><div class="pl-pname pl-pname--sub">{{ player.playerName }}</div>
                  <div class="pl-num">{{ player.redCardCount }}</div>
                  <div class="pl-num">{{ player.yellowCount }}</div>
                </div>
              </div>
              <p class="pl-foot">赛事数据统计由组委会提供</p>
            </div>
            <p v-else class="pl-empty-tip">还没有相关赛事数据，组委会正在录入中</p>
          </template>

          <template v-else-if="listData.id === 'assistList'">
            <div class="pl-grid pl-grid--fb3 pl-head">
              <span>球员</span><span>球队</span><span>次数</span>
            </div>
            <div
              v-for="(assister, idx) in listData.assistList"
              :key="assister.id"
              class="pl-grid pl-grid--fb3 pl-row"
              :class="{ 'pl-row--alt': idx % 2 === 1 }"
            >
              <div class="pl-player">
                <span class="pl-rank" :class="{ 'pl-rank--top': assister.top < 4 }">{{ assister.top }}</span>
                <span class="pl-pname">{{ assister.playerName }}</span>
              </div>
              <div class="pl-team">
                <img v-if="assister.team.badge" :src="filterImage(assister.team.badge, 20, 20)" alt="">
                <span>{{ assister.team.teamAlias || assister.team.name }}</span>
              </div>
              <div class="pl-num">
                {{ assister.assistCount }}<template v-if="assister.penaltyCount > 0">({{ assister.penaltyCount }})</template>
              </div>
            </div>
            <p v-if="!listData.assistList || !listData.assistList.length" class="pl-empty-tip">还没有相关赛事数据，组委会正在录入中</p>
            <p v-else class="pl-foot">赛事数据统计由组委会提供</p>
          </template>
        </div>
      </div>

      <!-- 篮球 -->
      <div v-else-if="match.sportType === '篮球'" class="pl-box">
        <aside class="pl-side pl-side--b200">
          <button
            v-for="(item, i) in matchesType.basketball"
            :key="i"
            type="button"
            class="pl-side__item"
            :class="{ 'pl-side__item--active': listData.id === item.id }"
            @click="getInit(item.id, item.api)"
          >
            {{ item.val }}
          </button>
        </aside>
        <div class="pl-panel">
          <template v-if="listData.id === 'shooterList'">
            <div class="pl-grid pl-grid--bb4 pl-head">
              <span>球员</span><span>球队</span><span>场均得分</span><span>场次</span>
            </div>
            <div
              v-for="(shooter, idx) in listData.shooterList"
              :key="shooter.id"
              class="pl-grid pl-grid--bb4 pl-row"
              :class="{ 'pl-row--alt': idx % 2 === 1 }"
            >
              <div class="pl-player">
                <span class="pl-rank" :class="{ 'pl-rank--top': shooter.top < 4 }">{{ shooter.top }}</span>
                
                <span class="pl-pname">{{ shooter.playerName }}</span>
              </div>
              <div class="pl-team">
                <img v-if="shooter.team.badge" :src="filterImage(shooter.team.badge, 20, 20)" alt="">
                <span>{{ shooter.team.teamAlias || shooter.team.name }}</span>
              </div>
              <div class="pl-num">{{ (shooter.avgCount * 1).toFixed(1) }}</div>
              <div class="pl-num">{{ shooter.gameCount }}</div>
            </div>
            <p v-if="!listData.shooterList || !listData.shooterList.length" class="pl-empty-tip">还没有相关赛事数据，组委会正在录入中</p>
            <p v-else class="pl-foot">赛事数据统计由组委会提供</p>
          </template>
          <template v-else-if="listData.id === 'assistList'">
            <div class="pl-grid pl-grid--fb3 pl-head">
              <span>球员</span><span>球队</span><span>助攻</span>
            </div>
            <div
              v-for="(assister, idx) in listData.assistList"
              :key="assister.id"
              class="pl-grid pl-grid--fb3 pl-row"
              :class="{ 'pl-row--alt': idx % 2 === 1 }"
            >
              <div class="pl-player">
                <span class="pl-rank" :class="{ 'pl-rank--top': assister.top < 4 }">{{ assister.top }}</span>
                
                <span class="pl-pname">{{ assister.playerName }}</span>
              </div>
              <div class="pl-team">
                <img v-if="assister.team.badge" :src="filterImage(assister.team.badge, 20, 20)" alt="">
                <span>{{ assister.team.teamAlias || assister.team.name }}</span>
              </div>
              <div class="pl-num">{{ assister.assistCount }}</div>
            </div>
            <p v-if="!listData.assistList || !listData.assistList.length" class="pl-empty-tip">还没有相关赛事数据，组委会正在录入中</p>
            <p v-else class="pl-foot">赛事数据统计由组委会提供</p>
          </template>
          <template v-else-if="listData.id === 'ReboundsTop'">
            <div class="pl-grid pl-grid--fb3 pl-head">
              <span>球员</span><span>球队</span><span>篮板</span>
            </div>
            <div
              v-for="(row, idx) in listData.ReboundsTop"
              :key="row.id"
              class="pl-grid pl-grid--fb3 pl-row"
              :class="{ 'pl-row--alt': idx % 2 === 1 }"
            >
              <div class="pl-player">
                <span class="pl-rank" :class="{ 'pl-rank--top': row.top < 4 }">{{ row.top }}</span>
                
                <span class="pl-pname">{{ row.playerName }}</span>
              </div>
              <div class="pl-team">
                <img v-if="row.team.badge" :src="filterImage(row.team.badge, 20, 20)" alt="">
                <span>{{ row.team.teamAlias || row.team.name }}</span>
              </div>
              <div class="pl-num">{{ row.reboundCount }}</div>
            </div>
            <p v-if="!listData.ReboundsTop || !listData.ReboundsTop.length" class="pl-empty-tip">还没有相关赛事数据，组委会正在录入中</p>
            <p v-else class="pl-foot">赛事数据统计由组委会提供</p>
          </template>
          <template v-else-if="listData.id === 'Interception'">
            <div class="pl-grid pl-grid--fb3 pl-head">
              <span>球员</span><span>球队</span><span>抢断</span>
            </div>
            <div
              v-for="(row, idx) in listData.Interception"
              :key="row.id"
              class="pl-grid pl-grid--fb3 pl-row"
              :class="{ 'pl-row--alt': idx % 2 === 1 }"
            >
              <div class="pl-player">
                <span class="pl-rank" :class="{ 'pl-rank--top': row.top < 4 }">{{ row.top }}</span>
                
                <span class="pl-pname">{{ row.playerName }}</span>
              </div>
              <div class="pl-team">
                <img v-if="row.team.badge" :src="filterImage(row.team.badge, 20, 20)" alt="">
                <span>{{ row.team.teamAlias || row.team.name }}</span>
              </div>
              <div class="pl-num">{{ row.stealCount }}</div>
            </div>
            <p v-if="!listData.Interception || !listData.Interception.length" class="pl-empty-tip">还没有相关赛事数据，组委会正在录入中</p>
            <p v-else class="pl-foot">赛事数据统计由组委会提供</p>
          </template>
          <template v-else-if="listData.id === 'CapsTop'">
            <div class="pl-grid pl-grid--fb3 pl-head">
              <span>球员</span><span>球队</span><span>盖帽</span>
            </div>
            <div
              v-for="(row, idx) in listData.CapsTop"
              :key="row.id"
              class="pl-grid pl-grid--fb3 pl-row"
              :class="{ 'pl-row--alt': idx % 2 === 1 }"
            >
              <div class="pl-player">
                <span class="pl-rank" :class="{ 'pl-rank--top': row.top < 4 }">{{ row.top }}</span>
                
                <span class="pl-pname">{{ row.playerName }}</span>
              </div>
              <div class="pl-team">
                <img v-if="row.team.badge" :src="filterImage(row.team.badge, 20, 20)" alt="">
                <span>{{ row.team.teamAlias || row.team.name }}</span>
              </div>
              <div class="pl-num">{{ row.blockCount }}</div>
            </div>
            <p v-if="!listData.CapsTop || !listData.CapsTop.length" class="pl-empty-tip">还没有相关赛事数据，组委会正在录入中</p>
            <p v-else class="pl-foot">赛事数据统计由组委会提供</p>
          </template>
        </div>
      </div>

      <!-- 棒球（统计平台：组别 + 指标） -->
      <div v-else-if="match.sportType === '棒球'" class="pl-box pl-box--baseball">
        <div class="pl-panel pl-panel--baseball">
          <div class="pl-grid pl-grid--fb3 pl-grid--bb-stat pl-head">
            <span>球员</span><span>球队</span>
            <span class="pl-head-stat">
              <span class="pl-head-stat__zh">{{ baseballStatHeaderZh }}</span>
              <span v-if="baseballStatHeaderEn" class="pl-head-stat__en">{{ baseballStatHeaderEn }}</span>
            </span>
          </div>
          <div
            v-for="(row, idx) in baseballList"
            :key="row.playerId != null ? row.playerId : idx"
            class="pl-grid pl-grid--fb3 pl-grid--bb-stat pl-row pl-row--baseball"
            :class="{ 'pl-row--alt': idx % 2 === 1 }"
          >
            <div class="pl-player">
              <span class="pl-rank" :class="{ 'pl-rank--top': row.top < 4 }">{{ row.top }}</span>
              <span class="pl-pname">{{ row.playerName }}</span>
            </div>
            <div class="pl-team">
              <img v-if="row.teamLogo" :src="filterImage(row.teamLogo, 20, 20)" alt="">
              <span>{{ row.teamName }}</span>
            </div>
            <div class="pl-num">{{ formatBaseballStatValue(row) }}</div>
          </div>
          <p v-if="!baseballList.length && !pageLoading" class="pl-empty-tip">还没有相关赛事数据，组委会正在录入中</p>
          <p v-else-if="baseballList.length" class="pl-foot">赛事数据统计由组委会提供</p>
        </div>
      </div>

      <!-- 橄榄球 -->
      <div v-else-if="match.sportType === '橄榄球'" class="pl-box pl-box--rugby">
        <aside class="pl-side pl-side--rugby">
          <div class="pl-side__rugby-scroll">
            <button
              v-for="(item, i) in rugbySideItems"
              :key="i"
              type="button"
              class="pl-side__item pl-side__item--lg"
              :class="{ 'pl-side__item--active': listData.id === item.id }"
              @click="getBMRugbyMatchPlayerStats(item.id)"
            >
              {{ item.val }}<br>{{ item.english }}
            </button>
          </div>
        </aside>
        <div class="pl-panel">
          <div class="pl-grid pl-grid--fb3 pl-head">
            <span>球员</span><span>球队</span>
            <span>{{ rugbyValueLabel }}</span>
          </div>
          <div
            v-for="(shooter, idx) in rugbyList"
            :key="shooter.id || idx"
            class="pl-grid pl-grid--fb3 pl-row"
            :class="{ 'pl-row--alt': idx % 2 === 1 }"
          >
            <div class="pl-player">
              <span class="pl-rank" :class="{ 'pl-rank--top': shooter.stats && shooter.stats.rank < 4 }">{{ shooter.stats.rank }}</span>
              
              <span class="pl-pname">{{ shooter.playerName }}</span>
            </div>
            <div class="pl-team">
              <img v-if="shooter.team.badge" :src="filterImage(shooter.team.badge, 20, 20)" alt="">
              <span>{{ shooter.team.teamAlias || shooter.team.name }}</span>
            </div>
            <div class="pl-num">{{ shooter.stats.value }}</div>
          </div>
          <p v-if="!rugbyList.length" class="pl-empty-tip">还没有相关赛事数据，组委会正在录入中</p>
          <p v-else class="pl-foot">赛事数据统计由组委会提供</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { DropdownMenu, DropdownItem, Sticky, Loading, Empty } from 'vant'
Vue.use(DropdownMenu).use(DropdownItem).use(Sticky).use(Loading).use(Empty)
import {
  getBMMatchList2,
  getBMShooterScores,
  getBMAssisterScores,
  getBMStageGamesByBMMatchId,
  getRedOrYellowCardByBMMatchId,
  getBMRebounds,
  getBMSteals,
  getBMBlocks,
  getBMRugbyMatchPlayerStats,
  getBMMatchInfo1,
  getBMUnionMatch,
} from '@/api/match'
import { fetchBaseballRankingsMeta, fetchBaseballPlayerRanking } from '@/api/baseball-stats'
import { QNImageUtil } from '@/utils'

export default {
  data() {
    return {
      unionMatchId: '',
      groupOptions: [],
      groupValue: '',
      pageLoading: true,
      match: {},
      obj: {},
      type: 'shooterList',
      listData: { id: '' },
      rugbyList: [],
      isShowBaqi: false,
      isShowTackle: false,
      accountId: '',
      baseballStageId: '',
      baseballStatOptions: [],
      baseballStatProp: '',
      baseballList: [],
      matchesType: {
        footballs: [
          { val: '得分', id: 'shooterList', api: 'getBMShooterScores' },
          { val: '助攻', id: 'assistList', api: 'getBMAssisterScores' },
          { val: '红黄牌', id: 'CardsData', api: 'getRedOrYellowCardByBMMatchId' },
        ],
        basketball: [
          { val: '得分', id: 'shooterList', api: 'getBMShooterScores' },
          { val: '助攻', id: 'assistList', api: 'getBMAssisterScores' },
          { val: '篮板', id: 'ReboundsTop', api: 'getBMRebounds' },
          { val: '抢断', id: 'Interception', api: 'getBMSteals' },
          { val: '盖帽', id: 'CapsTop', api: 'getBMBlocks' },
        ],
        rugby: [
          { val: '传球达阵', english: 'PaTD', id: 'passTd' },
          { val: '接球达阵', english: 'RecTD', id: 'recTd' },
          { val: '跑球达阵', english: 'RshTD', id: 'rushTd' },
          { val: '传球码数', english: 'PaYds', id: 'passYds' },
          { val: '接球码数', english: 'RecYds', id: 'recYds' },
          { val: '跑球码数', english: 'RshYds', id: 'rushYds' },
          { val: '抄截', english: 'Int', id: 'int' },
          { val: '拔旗', english: 'Flag Pull', id: 'flagPull' },
          { val: '擒抱', english: 'Tackle', id: 'flagPull' },
          { val: '擒杀', english: 'Sack', id: 'sack' },
        ],
      },
    }
  },
  computed: {
    /** 当前选中的组别 id，等价于原球员榜页 query.matchId */
    matchId() {
      return this.groupValue
    },
    unsupportedSport() {
      const s = this.match && this.match.sportType
      const ok = ['足球', '篮球', '橄榄球', '棒球']
      return !!(s && ok.indexOf(s) === -1)
    },
    unsupportedTip() {
      return `暂不支持「${this.match.sportType}」球员榜`
    },
    rugbyValueLabel() {
      const id = this.listData.id
      if (id === 'passYds' || id === 'recYds' || id === 'rushYds') return '码数'
      return '次数'
    },
    rugbySideItems() {
      const { isShowBaqi, isShowTackle } = this
      return this.matchesType.rugby.filter(
        item =>
          (item.val !== '拔旗' && item.val !== '擒抱') ||
          (item.val === '拔旗' && isShowBaqi) ||
          (item.val === '擒抱' && isShowTackle)
      )
    },
    baseballStatHeaderZh() {
      const o = this.baseballStatOptions.find(x => x.value === this.baseballStatProp)
      if (!o) return '数据'
      return o.labelZh || o.text || '数据'
    },
    baseballStatHeaderEn() {
      const o = this.baseballStatOptions.find(x => x.value === this.baseballStatProp)
      return (o && o.labelEn) || ''
    },
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.loadGroups()
  },
  methods: {
    cardGroupKey(group, gIdx) {
      const id = group && group.teamInfo && group.teamInfo.team && group.teamInfo.team.teamId
      return id != null ? `g-${id}` : `g-${gIdx}`
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    },
    loadGroups() {
      if (!this.unionMatchId) {
        this.pageLoading = false
        return
      }
      getBMMatchList2({ unionMatchId: this.unionMatchId }).then(res => {
        if (res === false) {
          this.groupOptions = []
          return
        }
        const list = (res && res.data && res.data.list) || []
        this.groupOptions = list.map(item => ({
          text: item.group || item.name || '组别',
          value: String(item.id),
        }))
        if (this.groupOptions.length) {
          this.groupValue = this.groupOptions[0].value
          this.afterGroupReady()
        }
      }).catch(() => {
        this.groupOptions = []
      }).finally(() => {
        if (!this.groupOptions.length) this.pageLoading = false
      })
    },
    onGroupChange() {
      this.afterGroupReady()
    },
    afterGroupReady() {
      if (!this.groupValue) return
      this.pageLoading = true
      this.listData = { id: '' }
      this.rugbyList = []
      this.baseballList = []
      this.baseballStatOptions = []
      this.baseballStatProp = ''
      this.type = 'shooterList'
      getBMStageGamesByBMMatchId({ matchId: this.groupValue })
        .then(res => {
          if (res === false) return null
          const data = res.data || {}
          this.obj = data.match
          const unionMatch = data.unionMatch || {}
          const m = this.obj || {}
          this.match = m
          const nameStr = (m.chineseName || '').split('_')
          document.title = '球员榜'
          if (typeof this.wxShare === 'function') {
            this.wxShare({
              title: (nameStr[0] || '') + this.getPromotion(unionMatch.beginDate, unionMatch.endDate),
              abstract: (nameStr[1] || nameStr[0] || '') + '/球员榜',
              image: m.icon && QNImageUtil.imageView(m.icon) || '',
            })
          }
          return { sport: m.sportType, stageData: data }
        })
        .then(payload => {
          if (!payload || !payload.sport) {
            this.pageLoading = false
            return null
          }
          const { sport, stageData } = payload
          getBMMatchInfo1({ matchId: this.groupValue, pageSize: 1000 })
            .then(data => {
              const gameType = data && data.match && data.match.gameType
              this.isShowBaqi = gameType && gameType.indexOf('腰旗') > -1
              this.isShowTackle = gameType && gameType.indexOf('装备') > -1
            })
            .catch(() => {})
          if (sport === '橄榄球') {
            this.type = 'passTd'
            this.listData.id = 'passTd'
            const first = this.matchesType.rugby[0]
            getBMShooterScores({
              matchId: this.groupValue,
              bmMatchId: this.groupValue,
              pageSize: 500,
            })
              .then(r => {
                if (r && r.data && r.data.match) this.match = r.data.match
              })
              .catch(() => {})
            this.getBMRugbyMatchPlayerStats(first.id)
            return null
          }
          if (sport === '棒球') {
            return this.bootstrapBaseball(stageData)
          }
          const list =
            sport === '足球'
              ? this.matchesType.footballs
              : sport === '篮球'
                ? this.matchesType.basketball
                : []
          const first = list[0]
          if (first) {
            this.getInit(first.id, first.api)
          } else {
            this.pageLoading = false
          }
          return null
        })
        .catch(() => {
          this.pageLoading = false
        })
    },
    flattenBaseballStatOptions(categories) {
      const out = []
      ;(categories || []).forEach(cat => {
        (cat.columns || []).forEach(col => {
          if (!col || !col.prop) return
          const label = col.label || ''
          const desc = col.desc || ''
          const text = [label, desc].filter(Boolean).join(' ')
          out.push({
            text: text || String(col.prop),
            value: col.prop,
            keepDecimalPlaces: col.keepDecimalPlaces,
            labelZh: label,
            labelEn: desc || '',
          })
        })
      })
      return out
    },
    onBaseballStatChange() {
      this.loadBaseballRankingList()
    },
    buildBaseballAccountId(stageData) {
      const m = stageData && stageData.match
      let id = m && m.accountId != null ? String(m.accountId) : ''
      if (id) return Promise.resolve(id)
      const preview = this.$route.query.preview || 0
      return getBMUnionMatch({ unionMatchId: this.unionMatchId, preview })
        .then(res => {
          if (res === false || !res || !res.data || !res.data.match) return ''
          const mid = res.data.match.accountId
          return mid != null ? String(mid) : ''
        })
        .catch(() => '')
    },
    bootstrapBaseball(stageData) {
      const stages = (stageData && stageData.stages) || []
      this.baseballStageId = stages.length ? String(stages[0].id) : String(this.groupValue)
      return this.buildBaseballAccountId(stageData).then(accountId => {
        this.accountId = accountId || ''
        if (!this.accountId || !this.baseballStageId) {
          this.baseballStatOptions = []
          this.baseballStatProp = ''
          this.baseballList = []
          this.pageLoading = false
          return undefined
        }
        return fetchBaseballRankingsMeta(this.accountId).then(meta => {
          const categories = meta.data && meta.data.categories
          this.baseballStatOptions = this.flattenBaseballStatOptions(categories)
          if (!this.baseballStatOptions.length) {
            this.baseballStatProp = ''
            this.baseballList = []
            this.pageLoading = false
            return undefined
          }
          const firstVal = this.baseballStatOptions[0].value
          if (!this.baseballStatProp || !this.baseballStatOptions.some(o => o.value === this.baseballStatProp)) {
            this.baseballStatProp = firstVal
          }
          return this.loadBaseballRankingList()
        })
          .catch(() => {
            this.baseballStatOptions = []
            this.baseballStatProp = ''
            this.baseballList = []
            this.pageLoading = false
          })
      })
    },
    applyBaseballRanks(rows, prop) {
      if (!rows || !rows.length) return []
      const list = rows.map(r => ({ ...r }))
      let rank = 1
      list[0].top = 1
      for (let i = 1; i < list.length; i++) {
        const a = list[i - 1][prop]
        const b = list[i][prop]
        if (a !== b) rank = i + 1
        list[i].top = rank
      }
      return list
    },
    loadBaseballRankingList() {
      if (!this.accountId || !this.baseballStageId || !this.baseballStatProp) {
        this.baseballList = []
        this.pageLoading = false
        return Promise.resolve()
      }
      this.pageLoading = true
      return fetchBaseballPlayerRanking({
        accountId: this.accountId,
        prop: this.baseballStatProp,
        stageId: this.baseballStageId,
        pageSize: 500,
      })
        .then(res => {
          const rows = Array.isArray(res.data) ? res.data : []
          this.baseballList = this.applyBaseballRanks(rows, this.baseballStatProp)
        })
        .catch(() => {
          this.baseballList = []
        })
        .finally(() => {
          this.pageLoading = false
        })
    },
    formatBaseballStatValue(row) {
      const prop = this.baseballStatProp
      const v = row[prop]
      if (v === undefined || v === null) return '—'
      const opt = this.baseballStatOptions.find(x => x.value === prop)
      const places = opt && opt.keepDecimalPlaces != null ? Number(opt.keepDecimalPlaces) : null
      const n = Number(v)
      if (!Number.isNaN(n) && places != null && places >= 0) {
        return n.toFixed(places)
      }
      return v
    },
    getPromotion(createDate, endDate) {
      if (!createDate || !endDate) return ''
      const now = Date.now()
      const start = new Date(createDate).getTime()
      const end = new Date(endDate).getTime()
      if (isNaN(start) || isNaN(end)) return ''
      if (now < start) return '-敬请期待'
      if (now >= start && now <= end) return '-激战正酣'
      return '-完美闭幕'
    },
    getInit(id, api) {
      this.type = id
      const ApiMap = {
        getBMShooterScores,
        getBMAssisterScores,
        getRedOrYellowCardByBMMatchId,
        getBMRebounds,
        getBMSteals,
        getBMBlocks,
      }
      const fn = ApiMap[api]
      if (!fn) return
      const params = {
        matchId: this.groupValue,
        bmMatchId: this.groupValue,
        pageSize: 500,
      }
      this.pageLoading = true
      fn(params).then(res => {
        if (res === false) return
        const data = res.data || {}
        this.match = data.match
        this.$set(this.listData, id, this.handleTopThree(data.players))
        this.listData.id = id
        if (id === 'shooterList') {
          const shooterScores = data.shooterScores || []
          this.$set(this.listData, id, this.handleTopThree(shooterScores, 'shooterList'))
          this.listData.id = id
        }
        if (id === 'CardsData') {
          const teams = data.teams
          const players = data.players
          this.$set(this.listData, id, this.groupTeamsInfo(teams, players))
          this.listData.id = id
        }
        if (id === 'assistList') {
          this.$set(this.listData, id, this.handleTopThree(data.assisterScores, 'assistList'))
          this.listData.id = id
        }
      }).catch(() => {}).finally(() => {
        this.pageLoading = false
      })
    },
    groupTeamsInfo(teams, players) {
      const groups = []
      const teamIds = []
      const teamsMapping = {}
      const playersGroupedByTeamId = {}
      let teamId
      for (let i = 0; i < (teams || []).length; i++) {
        const team = teams[i]
        teamId = team.teamId
        if (!teamsMapping[teamId]) {
          teamIds.push(teamId)
        }
        teamsMapping[teamId] = team
      }
      for (let j = 0; j < (players || []).length; j++) {
        const player = players[j]
        teamId = player.teamId
        if (playersGroupedByTeamId[teamId]) {
          playersGroupedByTeamId[teamId].push(player)
        } else {
          playersGroupedByTeamId[teamId] = [player]
        }
      }
      for (let k = 0; k < teamIds.length; k++) {
        teamId = teamIds[k]
        const teamInfo = teamsMapping[teamId]
        const teamPlayers = playersGroupedByTeamId[teamId]
        groups.push({ teamInfo, teamPlayers })
      }
      return groups
    },
    handleTopThree(shooterScores, type) {
      if (!shooterScores || shooterScores.length < 1) {
        return shooterScores || []
      }
      const match = this.match
      let topNumber = 1
      shooterScores[0].top = topNumber
      const topArray = [shooterScores[0]]
      for (let i = 1; i < shooterScores.length; i++) {
        const index = topArray.length - 1
        if (match.sportType === '足球') {
          if (type === 'shooterList') {
            if (topArray[index].goalCount !== shooterScores[i].goalCount) topNumber = i + 1
          } else if (type === 'assistList') {
            if (topArray[index].assistCount !== shooterScores[i].assistCount) topNumber = i + 1
          }
        } else if (match.sportType === '篮球') {
          if (topArray[index].avgCount !== shooterScores[i].avgCount) topNumber = i + 1
          else if (topArray[index].assistCount !== shooterScores[i].assistCount) topNumber = i + 1
          else if (topArray[index].reboundCount !== shooterScores[i].reboundCount) topNumber = i + 1
          else if (topArray[index].stealCount !== shooterScores[i].stealCount) topNumber = i + 1
          else if (topArray[index].blockCount !== shooterScores[i].blockCount) topNumber = i + 1
        }
        shooterScores[i].top = topNumber
        topArray.push(shooterScores[i])
      }
      return topArray
    },
    getBMRugbyMatchPlayerStats(id) {
      this.listData.id = id
      this.pageLoading = true
      getBMRugbyMatchPlayerStats({
        matchId: this.groupValue,
        pageSize: 500,
        index: id,
      })
        .then(res => {
          if (res === false) return
          const data = res.data || {}
          this.rugbyList = data.playerStatsList || []
        })
        .catch(() => {
          this.rugbyList = []
        })
        .finally(() => {
          this.pageLoading = false
        })
    },
  },
}
</script>

<style scoped lang="scss">
$blue: #337ecc;
$head-bg: #e8f2fc;
$zebra: #f5f5f5;
$side-text: #8b95a8;
$divide: #e5e9ef;

.pl-page {
  min-height: 100vh;
  background: #fff;
  box-sizing: border-box;
}

.pl-dropdown-wrap {
  padding: 12px 16px 4px;
  box-sizing: border-box;
  background: #fff;
}
.pl-state {
  padding: 80px 24px;
  text-align: center;
}

.pl-body {
  // padding: 8px 16px 24px;
  padding: 0 16px;
  margin-top: 12px;
}

.pl-box {
  display: flex;
  width: 100%;
  min-height: 50vh;
  box-sizing: border-box;
}

.pl-box--rugby {
  align-items: stretch;
}

.pl-side {
  width: 76px;
  flex-shrink: 0;
  background: #fff;
  // border-radius: 10px 0 0 10px;
  // border: 1px solid $divide;
  border-right: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.pl-side--b200 {
  width: 80px;
}

.pl-side--rugby {
  width: 88px;
  max-height: 70vh;
}

.pl-side__rugby-scroll {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  flex: 1;
}

.pl-side__item {
  width: 100%;
  border: none;
  background: #fff;
  padding: 14px 8px;
  font-size: 14px;
  color: $side-text;
  line-height: 1.35;
  text-align: center;
  cursor: pointer;
  position: relative;
  -webkit-tap-highlight-color: transparent;
  transition: background 0.15s ease, color 0.15s ease;
  height: 50px;
  box-sizing: border-box;

  &--lg {
    padding: 12px 5px;
    font-size: 12px;
    line-height: 1.25;
  }

  &--active {
    color: $blue;
    font-weight: 600;
    background: #ecf5ff;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: $blue;
      border-radius: 0 3px 3px 0;
    }
  }
}

.pl-panel {
  flex: 1;
  min-width: 0;
  // border: 1px solid $divide;
  // border-radius: 0 10px 10px 0;
  overflow: hidden;
  background: #fff;
}

.pl-grid {
  display: grid;
  align-items: center;
  min-height: 48px;
  padding: 0 12px;
  font-size: 14px;
  color: #303133;
}

.pl-grid--fb3 {
  grid-template-columns: 1fr 1.1fr 56px;
}

.pl-grid--bb-stat {
  grid-template-columns: 1fr 1.1fr minmax(88px, auto);
}

.pl-grid--bb4 {
  grid-template-columns: 1fr 1fr 52px 40px;
}

.pl-grid--card {
  grid-template-columns: 40px 1.2fr 48px 48px;
}

.pl-head {
  background: $head-bg;
  color: $blue;
  font-size: 13px;
  font-weight: 600;
  min-height: 36px;
  letter-spacing: 0.02em;

  span:last-child {
    text-align: right;
  }

  &.pl-grid--bb4 span:nth-child(3),
  &.pl-grid--bb4 span:nth-child(4) {
    text-align: right;
  }

  &.card-head span:nth-child(3),
  &.card-head span:nth-child(4) {
    text-align: right;
  }

  &.pl-grid--bb-stat {
    min-height: 44px;
    align-items: center;
  }

  .pl-head-stat {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    justify-self: end;
    text-align: right;
    line-height: 1.25;
    min-width: 0;
    padding: 2px 0;
  }

  .pl-head-stat__zh {
    display: block;
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
  }

  .pl-head-stat__en {
    display: block;
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.02em;
    white-space: nowrap;
    opacity: 0.92;
  }
}

.card-head {
  grid-template-columns: 40px 1.2fr 48px 48px;
}

.pl-row {
  border-bottom: 1px solid #f0f2f5;

  &:last-child {
    border-bottom: none;
  }

  &--alt {
    background: $zebra;
  }
  &--group {
    font-weight: 600;
    background: #fafafa;
  }
  &--sub {
    color: #909399;
    font-size: 13px;
  }
}

.pl-player {
  display: flex;
  align-items: center;
  min-width: 0;
}

.pl-rank {
  color: $blue;
  font-weight: 600;
  font-size: 16px;
  flex-shrink: 0;
  min-width: 10px;
  text-align: left;
  line-height: 1.2;
  margin-right: 2px;
}

.pl-dot {
  margin: 0 2px 0 0;
  color: #303133;
  flex-shrink: 0;
  font-weight: 600;
  user-select: none;
}

.pl-pname {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #303133;
  padding-left: 6px;
  flex: 1;
  min-width: 0;

  &--sub {
    white-space: normal;
    padding-left: 0;
  }
}

.pl-team {
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: hidden;

  img {
    width: 20px;
    height: 20px;
    margin-right: 6px;
    border-radius: 3px;
    object-fit: cover;
    flex-shrink: 0;
    background: #ebedf0;
  }

  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &--long {
    padding-left: 4px;
  }
}

.pl-num {
  text-align: right;
  color: #303133;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.pl-card-logo img {
  width: 22px;
  height: 22px;
  border-radius: 3px;
  object-fit: cover;
  vertical-align: middle;
}

.pl-empty-tip {
  padding: 48px 12px;
  text-align: center;
  color: #909399;
  font-size: 14px;
}

.pl-foot {
  padding: 12px 8px;
  text-align: center;
  color: #b5b5b5;
  font-size: 13px;
  background: #fff;
}

.pl-dropdown-menu--dual {
  ::v-deep .van-dropdown-menu__item {
    flex: 1;
    min-width: 0;
  }
}

.pl-box--baseball {
  .pl-panel--baseball {
    width: 100%;
    flex: 1;
  }
}

.pl-row--baseball {
  border-bottom: none;
}
</style>

<style lang="scss">
.van-sticky--fixed{
  padding: 12px 16px;
  background-color: #fff;
}
// .schedule-container{
  .van-dropdown-menu__bar{
    background-color: #FFFFFF;

    .van-dropdown-menu__item + .van-dropdown-menu__item {
      margin-left: 12px;
    }
    box-shadow: none;
  }
  .van-dropdown-menu__title::after {
    right: -12px;
    border: 4px solid;
    border-color: transparent transparent #686B6F #686B6F;
  }
  .van-dropdown-menu__item{
  border-radius: 5px;
  background-color: #F4F4F5;
  }
  .van-dropdown-menu__title--active::after {
    border-color: transparent transparent currentColor currentColor !important;
  }
// }
</style>
